import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestingRoutingModule } from './testing-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, TestingRoutingModule],
})
export class TestingModule {}
